<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <div class="spacing--margin-top">
    @if (soilAnalysis) {
      <app-soil-analysis-detail
        [soilAnalysis]="soilAnalysis"
        [showDescription]="false"
      ></app-soil-analysis-detail>
    }
  </div>
</agr-dialog>
